/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Team • über 50 Mitglieder',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Team • über 50 Mitglieder, einschließlich Ihnen',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Team • 1 Mitglied} other {Team • {0} Mitglieder}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Team • 1 Mitglied, einschließlich Ihnen} other {Team • {0} Mitglieder, einschließlich Ihnen}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Benötigt Zugriff auf Confluence',
  'fabric.mention.error.defaultAction': 'Versuchen Sie es in ein paar Sekunden erneut.',
  'fabric.mention.error.defaultHeadline': 'Irgendetwas ist schiefgelaufen',
  'fabric.mention.error.differentText': 'Versuchen Sie, einen anderen Text einzugeben.',
  'fabric.mention.error.loginAgain': 'Loggen Sie sich aus und wieder ein.',
  'fabric.mention.noAccess.label': 'Kein Zugriff',
  'fabric.mention.noAccess.warning': '{name} wird nicht benachrichtigt, da diese Person keinen Zugriff besitzt.',
  'fabric.mention.unknow.user.error': 'Unbekannter Benutzer {userId}'
};